module.exports = __webpack_public_path__ + "static/img/images_EL02.89a5560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/images_EL02.png
// module id = TOP7
// module chunks = 0